const rootActionPath = 'core/contactUsDashboard';

export const CONTACT_US_DASHBOARD_VIEW = `${rootActionPath}/VIEW`;
export const CONTACT_US_DASHBOARD_ORDER_INQUIRY_STEP_VIEW = `${rootActionPath}/orderInquiryStep/VIEW`;
